// Home.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { getToken } from "../utils";

function Home() {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const token = getToken();

  useEffect(() => {
    const fetchPosts = async () => {
      try {
      const response = await axios.get("http://localhost:8080/api/posts", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setPosts(response.data);
      } catch (err) {
        if (err.response && err.response.status === 500) {
          navigate("/500"); // Rediriger vers la page d'erreur 500
        } else {
          setError("Erreur lors de la récupération des posts\n" + err);
        }
      }
    };

    fetchPosts();
  }, [navigate]);

  return (
    <>
      <h1 className="text-3xl font-bold underline">Home Page</h1>
      <p>
        Aller à la page de <Link to="/login">connexion</Link>
      </p>
      {error && <p className="text-red-500">{error}</p>}
      <div className="grid grid-cols-4 gap-4">
        {posts.length > 0 ? (
          posts.map((post) => (
            <div key={post.id} className="border p-4">
              <h2 className="text-xl font-semibold">{post.title}</h2>
              <p className="text-gray-700">{post.body}</p>
            </div>
          ))
        ) : (
          <p>Aucun post disponible</p>
        )}
      </div>
    </>
  );
}

export default Home;
